export default __webpack_public_path__ + "static/media/hht1_storybook_06.3d42d51c.png";